import { render, staticRenderFns } from "./worldOceanDay.vue?vue&type=template&id=b2e80328&scoped=true&"
import script from "./worldOceanDay.vue?vue&type=script&lang=js&"
export * from "./worldOceanDay.vue?vue&type=script&lang=js&"
import style0 from "./worldOceanDay.vue?vue&type=style&index=0&id=b2e80328&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2e80328",
  null
  
)

export default component.exports